<template>
  <v-app>
    <div class="page-container">
      <div class="navbar-container">
        <Navbar :title="$t('text_select_payment_method')" :show-language-button="false" :show-back-button="true" />
      </div>
      <v-container class="main-container">
        <v-list>
          <v-list-item-group v-for="group in paymentData" :key="group.name" class="mb-5">
            <v-subheader v-if="group.code === 'OQ'" class="font-weight-bold"
              style="font-size: 1.2rem; color: black">QRIS</v-subheader>
            <v-subheader v-else class="font-weight-bold" style="font-size: 1.2rem; color: black">{{ group.name
            }}</v-subheader>
            <v-list-item v-for="item in group.detail" :key="item.code" @click="selectItem(item)"
              :disabled="vaCheckEnable(item, group.code) || validationAmount(group.code, group)"
              :class="{ 'selected-item': item.checked }" class="item-payment">
              <v-row no-gutters class="d-flex align-center">
                <v-col v-if="item.code !== 'CD'" cols="2" class="d-flex justify-center align-center">
                  <div class="image-payment mr-2">
                    <img :src="item.image" style="max-width: 60px;"
                      :style="{ borderRadius: item.code === 'OQ' ? '7px' : '0', filter: vaCheckEnable(item, group.code) || validationAmount(group.code, group) ? 'grayscale(1)' : 'none' }" />
                  </div>
                </v-col>
                <v-col :cols="'8'">
                  <div class="d-flex flex-column pl-2">
                    <span class="font-weight-normal">{{ item.name }}</span>
                    <span class="text-caption caption"
                      v-if="item.code === 'ShopeePay' && !$vuetify.breakpoint.smAndDown">{{ $t('text_only_for_mobile') }}</span>
                    <span class="text-caption caption" style="color: red;"
                      v-if="vaCheckEnable(item, group.code) || validationAmount(group.code, group)">{{
                        validationAmountMessage(group.code, group) }}</span>
                  </div>
                </v-col>
                <v-col cols="2" class="d-flex">
                  <v-spacer />
                  <v-list-item-action>
                    <div
                      :class="`outer-circle ${item.checked ? 'selected-circle' : ''} ${vaCheckEnable(item, group.code) || validationAmount(group.code, group) ? 'disabled' : ''}`">
                      <div class="inner-circle"></div>
                    </div>
                  </v-list-item-action>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <v-dialog v-model="dialogCC" persistent content-class="elevation-0">
          <v-container fluid>
            <v-row justify="center">
              <v-col cols="12" sm="8" md="6" lg="4" class="pa-0">
                <v-card class="card-material">
                  <div class="d-flex grow flex-wrap">
                    <div class="v-card--material__heading v-sheet">
                      <v-img :src="getImgBg(currentCardBackground)"
                        gradient="to bottom, rgba(6, 2, 29, 0.45), rgba(6, 2, 29, 0.45)"
                        :class="[`white--text card-flip`, { 'isFlip': isCardFlipped }]">
                        <div class="card-item__wrapper flex-column front">
                          <div class="mb-auto d-flex">
                            <div class="d-flex">
                              <img :src="getImgPng('chip')" class="card-item__chip">
                            </div>
                            <v-spacer />
                            <div class="d-flex">
                              <div class="card-item__type">
                                <transition name="fade">
                                  <img v-if="getCardType" :key="getCardType" :src="getImgPng(getCardType)">
                                </transition>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-center">
                            <label>
                              <template v-if="getCardType !== 'amex'">
                                <span v-for="(n, $index) in otherCardMask" :key="$index">
                                  <transition name="slide-fade-up">
                                    <div v-if="$index > 4 && $index < 14 && cardNumber.length > $index && n.trim() !== ''"
                                      class="card-item__numberItem">
                                      *
                                    </div>
                                    <div v-else-if="cardNumber.length > $index" :key="$index"
                                      class="card-item__numberItem" :class="{ '-active': n.trim() === '' }">
                                      {{ cardNumber[$index] }}
                                    </div>
                                    <div v-else :key="$index + 1" class="card-item__numberItem"
                                      :class="{ '-active': n.trim() === '' }">
                                      {{ n }}
                                    </div>
                                  </transition>
                                </span>
                              </template>
                              <template v-else>
                                <span v-for="(n, $index) in amexCardMask" :key="$index">
                                  <transition name="slide-fade-up">
                                    <div v-if="$index > 4 && $index < 14 && cardNumber.length > $index && n.trim() !== ''"
                                      class="card-item__numberItem">
                                      *
                                    </div>
                                    <div v-else-if="cardNumber.length > $index" :key="$index"
                                      class="card-item__numberItem" :class="{ '-active': n.trim() === '' }">
                                      {{ cardNumber[$index] }}
                                    </div>
                                    <div v-else :key="$index + 1" class="card-item__numberItem"
                                      :class="{ '-active': n.trim() === '' }">
                                      {{ n }}
                                    </div>
                                  </transition>
                                </span>
                              </template>
                            </label>
                          </div>
                          <div class="mt-auto d-flex">
                            <v-spacer />
                            <div class="d-flex align-center flex-column" style="width: 70px;">
                              <div class="__expiredText">
                                {{ $t('text_expiration_date') }}
                              </div>
                              <div class="__expiredDate">
                                <label for="cardMonth" class="card-item__dateItem">
                                  <transition name="slide-fade-up">
                                    <span v-if="cardMonth" :key="cardMonth">{{ cardMonth }}</span>
                                    <span v-else key="2">MM</span>
                                  </transition>
                                </label>
                                /
                                <label for="cardYear" class="card-item__dateItem">
                                  <transition name="slide-fade-up">
                                    <span v-if="cardYear" :key="cardYear">{{ String(cardYear).slice(2, 4) }}</span>
                                    <span v-else key="2">YY</span>
                                  </transition>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card-item__wrapper flex-column back">
                          <div class="mb-auto d-flex">
                            <div class="backBlack" />
                          </div>
                          <div class="d-flex justify-center body-back flex-column">
                            <div class="card-cvv">
                              CVV
                            </div>
                            <div class="card__secret">
                              <span v-for="(n, $index) in cardCVN" :key="$index">
                                *
                              </span>
                            </div>
                          </div>
                          <div class="mt-auto d-flex body-back">
                            <v-spacer />
                            <div class="d-flex">
                              <div class="card-item__type">
                                <transition name="fade">
                                  <img v-if="getCardType" :key="getCardType" :src="getImgPng(getCardType)">
                                </transition>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-img>
                    </div>
                  </div>
                  <v-card-text>
                    <ValidationObserver ref="observer">
                      <v-form>
                        <v-row>
                          <v-col cols="12" class="pt-0">
                            <ValidationProvider v-slot="{ errors }" name="credit_card" rules="required|creditCard">
                              <v-text-field v-model="cardNumber" v-mask="generateCardNumberMask" :label="$t('text_card_number')" dense
                                :error-messages="errors" />
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="6" class="pt-0">
                            <ValidationProvider v-slot="{ errors }" name="bulan" rules="required">
                              <v-select 
                                v-model="cardMonth" 
                                item-text="text" 
                                item-value="value" 
                                dense 
                                :items="listMonth"
                                :label="$t('text_month')"
                                :error-messages="errors"
                              />
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="6" class="pt-0">
                            <ValidationProvider v-slot="{ errors }" name="tahun" rules="required">
                              <v-select 
                                v-model="cardYear" 
                                dense 
                                :items="listYear || []" 
                                :label="$t('text_year')"
                                :error-messages="errors"
                              />
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="6" class="pt-0">
                            <ValidationProvider v-slot="{ errors }" name="credit_card_cvn"
                              rules="required|creditCardCVN">
                              <v-text-field v-model="cardCVN" v-mask="'####'" maxlength="4" label="CVV" dense
                                :error-messages="errors" @focus="isCardFlipped = true" @blur="isCardFlipped = false" />
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-form>
                    </ValidationObserver>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" style="text-transform: uppercase" text @click="closeCreditCard()">
                      {{ $t('text_close') }}
                    </v-btn>
                    <v-btn color="primary" :disabled="loading_payment" @click="selectCreditCard()">
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-dialog>

        <v-dialog v-model="dialogIframe" persistent>
          <v-card>
            <v-card-text>
              <iframe v-if="data_xendit" height="450" width="100%" frameborder="0" marginheight="0" marginwidth="0"
                :src="data_xendit.payer_authentication_url" />
            </v-card-text>
          </v-card>
        </v-dialog>

        <div v-if="selectedPayment" class="btn-nav-footer">
          <div class="d-flex justify-space-between align-center mb-2">
            <span class="font-weight-medium">{{
              formatCurrency(totalReservationPrice, true)
            }}</span>
            <span class="font-weight-medium">{{
              selectedPayment ? selectedPayment.name : ""
            }}</span>
          </div>
          <v-btn color="success" :elevation="0" class="btn-submit font-weight-bold"
            :disabled="getLoadingAxiosState || loading_payment || !selectedPayment" @click="handlePayment">
            {{ $t('text_pay_now') }}
          </v-btn>
        </div>
      </v-container>
    </div>
  </v-app>
</template>

<script>
import Navbar from "@/components/Layouts/Navbar.vue";
import { getListPayment, orderPayment } from "@/api/payment";
import { formatCurrency } from "@/utils/currencyUtils";
import { mapGetters } from "vuex";
import qrisImg from "@/assets/images/qris.png";
import ccImage from "@/assets/images/cc-type/credit-card.png"
import { setQueryParam } from '@/utils/customQuery'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
import i18n from "@/plugins/i18n";
export default {
  name: "Payment",
  components: {
    Navbar,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      paymentData: [],
      selectedPayment: null,
      loading_payment: false,
      dialogCC: false,
      currentCardBackground: 1,
      cardName: '',
      cardNumber: '',
      cardMonth: '',
      cardYear: '',
      cardCVN: '',
      amexCardMask: '#### ###### #####',
      otherCardMask: '#### #### #### ####',
      cardNumberTemp: '',
      isCardFlipped: false,
      data_xendit: {},
      listMonth: [
        { id: 1, value: '01', text: i18n.t('january') },
        { id: 2, value: '02', text: i18n.t('february') },
        { id: 3, value: '03', text: i18n.t('march') },
        { id: 4, value: '04', text: i18n.t('april') },
        { id: 5, value: '05', text: i18n.t('may') },
        { id: 6, value: '06', text: i18n.t('june') },
        { id: 7, value: '07', text: i18n.t('july') },
        { id: 8, value: '08', text: i18n.t('august') },
        { id: 9, value: '09', text: i18n.t('september') },
        { id: 10, value: '10', text: i18n.t('october') },
        { id: 11, value: '11', text: i18n.t('november') },
        { id: 12, value: '12', text: i18n.t('december') }
      ],
      dialogIframe: false,
    };
  },
  computed: {
    ...mapGetters([
      "totalReservationPrice",
      "dataCartReservation",
      "getStoreData",
      "getLoadingAxiosState"
    ]),
    getCardType() {
      const number = this.cardNumber
      let re = new RegExp('^4')
      if (number.match(re) != null) return 'visa'

      re = new RegExp('^(34|37)')
      if (number.match(re) != null) return 'amex'

      re = new RegExp('^5[1-5]')
      if (number.match(re) != null) return 'mastercard'

      re = new RegExp('^6011')
      if (number.match(re) != null) return 'discover'

      re = new RegExp('^9792')
      if (number.match(re) != null) return 'troy'

      return 'visa'
    },
    generateCardNumberMask() {
      return this.getCardType === 'amex' ? this.amexCardMask : this.otherCardMask
    },
    listYear() {
      const years = []
      var year = new Date().getFullYear()
      for (var i = 0; i < 12; i++) {
        years.push(year + i)
      }
      return years
    },
  },
  mounted() {
    this.cardNumberTemp = this.otherCardMask
    this.getListPaymentMethod();
  },
  methods: {
    formatCurrency,
    // credit card
    getImgPng(payment) {
      var images = require.context('@/assets/images/cc-type/', false, /\.png$/)
      return images('./' + payment + '.png')
    },
    getImgBg(cc) {
      var images = require.context('@/assets/images/cc/', false, /\.jpeg$/)
      return images('./' + cc + '.jpeg')
    },
    closeCreditCard() {
      this.dialogCC = false
      this.cardNumber = ''
      this.cardMonth = ''
      this.cardYear = ''
      this.cardCVN = ''
      this.$nextTick(() => this.$refs.observer.reset())
    },
    async selectCreditCard() {
      const isValid = await this.$refs.observer.validate()
      this.cardNumber = this.cardNumber.replace(/\s+/g, '')
      if (isValid) {
        console.log('this.cardNumber', this.cardNumber)
        const binCC = (this.cardNumber).substring(0, 6)
        window.Xendit.setPublishableKey(process.env.VUE_APP_XENDIT_KEY)
        this.$store.state.loading = true
        this.loading_payment = true
        window.Xendit.card.threeDSRecommendation({
          bin_number: binCC
        }, this.check3DS)
      }
    },
    check3DS(err, recommendation) {
      if (err) {
        this.$store.state.loading = false
        this.loading_payment = false;
        return false
      }
      if (recommendation.should_3ds === true) {
        this.cardNumber = this.cardNumber.replace(/\s+/g, '')
        window.Xendit.card.createToken({
          amount: this.totalReservationPrice,
          card_number: this.cardNumber,
          card_exp_month: this.cardMonth,
          card_exp_year: this.cardYear.toString(),
          card_cvn: this.cardCVN,
          is_multiple_use: false,
          should_authenticate: true
        }, this.xenditResponseHandler)
      } else {
        this.$store.state.show_error = true
        this.$store.state.error_message = 'For security, we only accept credit card with 3DS authentication. Please check with your credit card company for details.'
        this.$store.state.error_type = 422
      }
    },
    xenditResponseHandler(err, creditCardCharge) {
      this.$store.state.loading = false
      this.loading_payment = false;
      this.dialogIframe = false
      this.dialogCC = false
      this.data_xendit = creditCardCharge
      if (err) {
        this.$store.state.show_error = true
        this.$store.state.error_message = err.message
        this.$store.state.error_type = err.statusCode
      }
      if (creditCardCharge) {
        if (creditCardCharge.status === 'APPROVED' || creditCardCharge.status === 'VERIFIED') {
          this.creditCardSuccess(creditCardCharge)
        } else if (creditCardCharge.status === 'IN_REVIEW') {
          this.dialogIframe = true
        } else if (creditCardCharge.status === 'FRAUD') {
          this.displayError(creditCardCharge)
        } else if (creditCardCharge.status === 'FAILED') {
          this.displayError(creditCardCharge)
        }
      }
    },
    displayError(e) {
      this.$store.state.show_error = true
      this.$store.state.error_message = e.string ?? e.failure_reason
      this.dialogIframe = false
    },
    async creditCardSuccess(creditCardCharge) {
      this.dialogIframe = false
      const paymentCCBody = {
        remark: "PLACE_RESERVATION",
        item: this.dataCartReservation.map((item) => {
          return {
            layout_item_id: item.id,
            reserve_date: item.reservation_date.date,
            reserve_time: item.reserve_time,
            notes: item.item_place_reservation.notes,
          };
        }),
        payment: {
          payment_mode_id: this.selectedPayment.payment_id,
          bank_code: this.selectedPayment.code,
          cc_id: creditCardCharge.id,
          cc_authentication_id: creditCardCharge.authentication_id
        },
        url_id: this.$store.state.store_data?.url_id,
      };
      this.handlePay(paymentCCBody)
    },
    // end credit card
    async getListPaymentMethod() {
      this.$store.state.loading_axios = true;
      try {
        const { data } = await getListPayment({
          url_id: this.getStoreData.url_id,
          remark: "PLACE_RESERVATION",
        });
        const filteredDataitem = data.data.filter((item) => item.enabled === true || item.enabled === 1)
          .map((item) => ({
            ...item,
            detail: item.detail.filter((detail) => (detail.enabled === true || detail.enabled === 1) && item.code === 'CC' ? detail.code === 'CC' : true),
          }))
          .filter((item) => ['OQ', 'CC'].includes(item.code) ? true : item.detail.length > 0)
        // this.paymentData = data.data
        this.transformApiData(filteredDataitem);
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch("fetchToken");
        } else {
          this.$store.state.show_error = true;
          this.$store.state.error_message = e.string;
          this.$store.state.error_type = e.statusCode;
        }
      } finally {
        this.$store.state.loading_axios = false;
      }
    },
    transformApiData(apiData) {
      const desiredOrder = ["OQ", "CC", "BT", null, "CD"];
      const newOrder = [];

      desiredOrder.forEach((code) => {
        const item = apiData.find((paymentItem) => paymentItem.code === code);
        if (item) {
          newOrder.push(item);
        }
      });

      // Salin urutan lainnya yang tidak termasuk dalam urutan yang Anda inginkan
      apiData.forEach((item) => {
        if (!newOrder.includes(item)) {
          newOrder.push(item);
        }
      });

      function getImage(code) {
        switch (code) {
          case "OQ":
            return qrisImg;
          case "CC":
            return ccImage;
          default:
            return null;
        }
      }

      const newData = newOrder.map((item) => {
        if (item.detail.length === 0) {
          item.detail = [
            {
              payment_id: item.payment_id,
              payment_name: item.name,
              name: item.name,
              code: item.code,
              enabled: item.enabled,
              image: getImage(item.code) // Menggunakan kode sebagai nama file gambar
            },
          ];
        } else {
          item.detail = item.detail.map((detail) => {
            return {
              ...detail,
              payment_name: item.name,
            }
          })
        }
        return item;
      });

      this.paymentData = newData.filter((item) => item.code !== 'CD');
    },
    paymentCC() {
      this.currentCardBackground = Math.floor(Math.random() * 4 + 1)
      this.dialogCC = true;
    },
    selectItem(item) {
      // Function untuk mengaktifkan atau menonaktifkan pemilihan item
      if (this.selectedPayment) {
        this.selectedPayment.checked = false;
      }
      item.checked = !item.checked;
      this.selectedPayment = item.checked ? item : null;
    },
    async handlePayment() {
      if (this.selectedPayment.code === 'CC') {
        this.paymentCC()
      } else if (this.selectedPayment.code === 'OVO' || this.selectedPayment.code === 'LINKAJA') {
        this.$store.dispatch("setPyment", this.selectedPayment);
        this.$store.dispatch("set_router_data", { name: 'payment-ewallet', params: { code: this.selectedPayment.code, payment_id: this.selectedPayment.payment_id } });
        setQueryParam('page', 'payment-ewallet')
        setQueryParam('code', this.selectedPayment.code)
        setQueryParam('payment_id', this.selectedPayment.payment_id)
      } else {
        const url = new URL(window.location.href);
        const paymentBody = {
          remark: "PLACE_RESERVATION",
          item: this.dataCartReservation.map((item) => {
            return {
              layout_item_id: item.id,
              reserve_date: item.reservation_date.date,
              reserve_time: item.reserve_time,
              notes: item.item_place_reservation.notes,
            };
          }),
          payment: {
            payment_mode_id: this.selectedPayment.payment_id,
            bank_code: this.selectedPayment.code,
            redirect_url: `${url.origin}/reservation-place?page=order-detail`,
          },
          url_id: this.$store.state.store_data?.url_id,
        };
        this.handlePay(paymentBody);
      }
    },
    async handlePay(body) {
        this.loading_payment = true;

        try {
          const paymentData = await orderPayment(body, {
            url_id: this.$store.state.store_data?.url_id,
          });
          const data = paymentData.data.data
          this.$store.dispatch("create_order", data);
          this.$store.dispatch("removeAllReservation");
          if (data.payment_log) {
            if (data.payment_log.payment_source === "CREDIT-CARD") {
              this.$store.dispatch("set_router_data", { name: 'order-detail', params: { order_id: data.id } });
              setQueryParam('page', 'order-detail')
              setQueryParam('order_id', data.id)
            } else if (data.payment_log.payment_source === "VIRTUAL-ACCOUNT") {
              // this.$router.push({ name: "va_order" });
              this.$store.dispatch("set_router_data", { name: 'payment-va' });
              setQueryParam('page', 'payment-va')
            } else if (data.payment_log.payment_source === "OLSERA-QRIS") {
              // this.$router.push({ name: "qris" });
              this.$store.dispatch("set_router_data", { name: 'payment-qris' });
              setQueryParam('page', 'payment-qris')
            } else {
              if (data.payment_log.checkout_url) {
                window.location = data.payment_log.checkout_url;
              }
            }
          }
        } catch (e) {
          if (e.statusCode === 401) {
            this.$store.dispatch("fetchToken");
          } else {
            this.$store.state.show_error = true;
            this.$store.state.error_message = e.string;
            this.$store.state.error_type = e.statusCode;
          }
        } finally {
          this.$store.state.loading_axios = false;
          this.loading_payment = false;
        }
    },
    vaCheckEnable(child, code) {
      if (child.enabled === 1) {
        if (child.code === 'ShopeePay' && !this.$vuetify.breakpoint.smAndDown) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    validationAmount(code, item) {
      if (['BT'].includes(code) && this.totalReservationPrice < 10000) {
        return true
      } else if (['CC'].includes(code) && this.totalReservationPrice < 5000) {
        return true
      } else if (item.name === 'E-Wallet' && this.totalReservationPrice < 5000) {
        return true
      } else if (code === 'OQ' && this.totalReservationPrice < 1000) {
        return true
      } else {
        return false
      }
    },
    validationAmountMessage(code, item) {
      if (['BT'].includes(code) && this.totalReservationPrice < 10000) {
        return i18n.t('text_minimal_purchase') + ' Rp 10.000'
      } else if (['CC'].includes(code) && this.totalReservationPrice < 5000) {
        return i18n.t('text_minimal_purchase') + ' Rp 5.000'
      } else if (item.name === 'E-Wallet' && this.totalReservationPrice < 5000) {
        return i18n.t('text_minimal_purchase') + ' Rp 5.000'
      } else if (code === 'OQ' && this.totalReservationPrice < 1000) {
        return i18n.t('text_minimal_purchase') + ' Rp 1.000'
      } else {
        return ''
      }
    }
  },
};
</script>

<!-- <style>

</style> -->
